/* Rohini 10/29/2022 3075154998 add classname globally for the textfields and buttons */
/* Rohini 10/29/2022 3075154998 add classname globally for the buttons */
import React, {useState, useContext} from 'react';
import {Formik} from 'formik';
import {Button, Grid, TextField, FormHelperText} from '@material-ui/core';
import {ThemeContext} from '../../../../../../themes/ThemeProvider';
import ErrorBoundaryForComponents from '../../../../../../util/ErrorBoundaryForComponents';
import SearchFilterTable from './SearchFilterTable';
import * as Yup from 'yup';

const FieldSearch = ({
  setSearchData,
  searchData,
  setSelectedRows,
  selectedRows,
  setSelectedSummaryArray,
  handleClose,
  setLetterConstantData,
  setGlobalFieldData,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const schema = Yup.object().shape({
    code: Yup.string().matches(
      /^[a-zA-Z0-9]+$/,
      'White space and special character are not allowed',
    ),
  });
  const initialValues = {
    code: '',
    description: '',
  };

  const handleSubmit = (data) => {
    setSubmit(true);
    setSearchFlag(true);
    setSearchData(data);
  };

  const [, setSearchFlag] = useState(false);
  const [submit, setSubmit] = useState(false);

  const handleReset = (values) => {
    setSearchData(initialValues);
  };
  return (
    <div className={classes.dialoguecardStyles}>
      <div>
        <Formik
          onSubmit={(values) => handleSubmit(values)}
          initialValues={initialValues}
          enableReinitialize
          validationSchema={schema}
          onReset={() => handleReset()}
        >
          {(props) => {
            const {touched, errors, values, handleChange, handleSubmit, handleReset, handleBlur} =
              props;
            return (
              <div>
                <form autoComplete="off" noValidate onSubmit={handleSubmit} onReset={handleReset}>
                  <div>
                    <ErrorBoundaryForComponents>
                      <Grid container className="global-field-textfields" spacing={2}>
                        <Grid item xs={4} className="form-group">
                          <TextField
                            margin="dense"
                            variant="outlined"
                            placeholder="Enter Filter Code"
                            label="Filter Code"
                            className={` ${classes.labelName} ${classes.inputLabel}`}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            name="code"
                            value={values?.code?.toUpperCase()}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            fullWidth
                            touched={touched.code}
                            error={Boolean(touched.code && errors.code)}
                          />
                          <FormHelperText>
                            {touched.code && errors.code && errors.code}
                          </FormHelperText>
                        </Grid>
                        <Grid item xs={4} className="form-group">
                          <TextField
                            margin="dense"
                            variant="outlined"
                            placeholder="Enter Filter Description"
                            label="Filter Description"
                            className={` ${classes.labelName} ${classes.inputLabel}`}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            name="description"
                            value={values.description}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            fullWidth
                          />
                        </Grid>
                        <Grid item xs={4} className="form-group d-flex justify-content-end align-items-center">
                          <Button
                            variant="outlined"
                            className={`mx-1 reset-btn`}
                            onClick={handleReset}
                          >
                            Clear
                          </Button>
                          <Button variant="outlined" type="submit" className={`mx-1 search-btn`}>
                            Search
                          </Button>
                        </Grid>
                      </Grid>
                    </ErrorBoundaryForComponents>
                  </div>
                </form>
              </div>
            );
          }}
        </Formik>
      </div>
      <SearchFilterTable
        submit={submit}
        setSubmit={setSubmit}
        searchData={searchData}
        setSelectedRows={setSelectedRows}
        selectedRows={selectedRows}
        handleClose={handleClose}
        setGlobalFieldData={setGlobalFieldData}
        setLetterConstantData={setLetterConstantData}
      />
    </div>
  );
};

export default FieldSearch;
